import React from "react";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function BarChart({ x, y, data = [], labels = ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],hoverLabels = [] }) {
	const options = {
		indexAxis: "y",
		elements: {
			bar: {
				borderWidth: 0,
				borderRadius: 4,
			},
		},
		maintainAspectRatio: false,
		responsive: true,
		plugins: {
			legend: {
				display: false,
			},
			tooltip: {
				enabled: true,
				callbacks: {
    				title: function (context) {
      					const index = context[0].dataIndex;
						console.log('Hover index:', index, 'Label:', hoverLabels[index]);
      						return hoverLabels[index] || context[0].label;
    				},
    				label: function (context) {
      					const value = context.raw;
      					const label = context.dataset.label || '';
      					return `${label}: ${value}`;
    				},
				},
			},
		},
		scales: {
			y: {
				beginAtZero: true,
				grid: {
					display: false,
					drawBorder: false,
				},
				ticks: {
					// color: '#333',
					font: {
						size: 12,
					},
					callback: function (value, index) {
						let label = labels[index] || "";
						if (label.length > 25) {
							// Adjust length threshold as needed
							let splitIndex = label.lastIndexOf(" ", 25);
							return [label.slice(0, splitIndex), label.slice(splitIndex + 1)];
						}
						return label;
					},
				},
			},
			x: {
				display: true,

				grid: {
					display: false,
					drawBorder: false,
				},
				ticks: {
					display: false,
				},
			},
		},
	};

	const chartData = {
		labels,
		datasets: [
			{
				label: y,
				data: data,
				backgroundColor: "rgba(255, 99, 132, 0.5)",
				borderWidth: 0,
				barThickness: 20,
				maxBarThickness: 25,
			},
		],
	};

	return (
		<div
			style={{
				height: "350px",
				width: "100%",
				display: "flex",
				flexDirection: "row",
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			<Bar options={{ ...options }} data={chartData} />
		</div>
	);
}

export default BarChart;
